import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    SellerSuggestionsRequest,
    SellerListRequest,
    FavouriteSellerCardDto,
    GetSellerListApiResponse
} from 'src/state/services/types/webapi-discover-generated';
import qs from 'qs';
import { isServer } from 'tradera/utils/nextjs';

export type ParsedSellers = {
    sellers?: FavouriteSellerCardDto[] | null;
    totalSellers: number;
    totalPages: number;
};

export const sellerListApi = createApi({
    reducerPath: 'sellerListApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (build) => ({
        getSellerList: build.query<
            ParsedSellers,
            | (SellerListRequest & { type: 'favourites' })
            | (SellerSuggestionsRequest & { type: 'suggested' })
        >({
            query: (params) => {
                const query = qs.stringify(params);
                const baseUrl = isServer ? '' : '/api/webapi';
                const listType =
                    params.type === 'favourites'
                        ? 'seller-list'
                        : 'seller-suggestions';
                return `${baseUrl}/discover/${listType}?${query}`;
            },
            transformResponse: (
                response: GetSellerListApiResponse,
                _,
                arg
            ) => ({
                sellers: response.favouriteSellerCardDtos,
                totalSellers: response.totalSellers,
                totalPages: Math.ceil(response.totalSellers / arg.maxSellers!)
            })
        }),
        followSeller: build.mutation<void, number>({
            query: (sellerId) => ({
                url: '/my/favourite-sellers/add',
                method: 'POST',
                body: { sellerId }
            })
        }),
        unfollowSeller: build.mutation<void, number>({
            query: (sellerId) => ({
                url: '/my/favourite-sellers/remove',
                method: 'POST',
                body: { ids: [sellerId] }
            })
        })
    })
});

export const {
    useGetSellerListQuery,
    useFollowSellerMutation,
    useUnfollowSellerMutation,
    util
} = sellerListApi;
